import { Meta, StoryObj } from "@storybook/nextjs-vite";
import { Pill } from "./Pill";

const meta: Meta = {
  title: "Pill",
  component: Pill,
};

export default meta;

export const Default: StoryObj<typeof Pill> = {
  args: {
    children: "Pill",
  },
};
